// extracted by mini-css-extract-plugin
export var dividerLine = "_8p-3";
export var itemImage = "_8p-9";
export var lightDivider = "_8p-4";
export var modalContent = "_8p-5";
export var modalContentCompact = "_8p-6";
export var productCard = "_8p-a";
export var productImage = "_8p-b";
export var productImageCompact = "_8p-7";
export var productImagePlaceholder = "_8p-c";
export var productImagePlaceholderCompact = "_8p-8";
export var progressBarBackground = "_8p-1";
export var progressBarContainer = "_8p-0";
export var progressBarFill = "_8p-2";